import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";
import moment from "moment";
import Swal from "sweetalert2";

import {
    Button, Input, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form, FormGroup, FormFeedback,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import FilesCustom from 'components/FilesCustom';
import ShowDetails from 'components/ShowDetails';
import Historical from 'components/Historical';

import CNavbar from 'components/CNavbar';

import * as commonFunc from 'scripts/common';
import CDataTable, { showDtPrevID, showDtSelID, showDtNextID, setDtNoSelect } from "components/CDataTable";

import { withRouter } from 'components/withRouter';

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Editor } from 'components/TinyMCE-react';

import { saveTicket } from "views/pages/ManageTickets";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import CardMat from 'components/CardMat';

class ManageMaterials extends Component {
    static displayName = ManageMaterials.name;

    static materialModels;
    static refreshCb;
    static modalRoot;

    static loadReportCb;

    constructor(props) {
        super(props);

        this.materialGen = React.createRef(null);

        var defMatCategoryGroupKey = "";
        var defMatPageModels = "";
        if (props.searchParams) {
            defMatCategoryGroupKey = props.searchParams.get("categoryGroupKey") || "";
            defMatPageModels = props.searchParams.get("pageModels") || "";
        }

        this.state = {
            materials: [], curMaterial: null, curMaterialId: 0, status: [], defaultStatus: 4000, curStatus: 4000/*, historicalReports: true*/, loading: true, dataStamp: 0, activeTab: "1",
            expandAll: null,
            expandStamp: 0,
            title: props.i18nManager.t("material.noSelected"), editionMode: false, categoryGroupKey: defMatCategoryGroupKey, pageModels: defMatPageModels
        };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            commonFunc.getMethod("../api/material/GetMaterialModels", { id: -1 }).then((responseModels) => {
                var dataModels = responseModels.data;
                if (dataModels.isSuccess) {

                    context.materialModels = {};
                    dataModels.result.models.forEach((model) => {
                        context.materialModels[model.extID] = JSON.parse(model.value);
                    });

                    //context.materialModels["CONTACTS"] = {};
                    //context.materialModels["DT_CTCS"] = {};
                    //context.materialModels["DLG_CONTACT"] = {};
                    


                    //Chargement via url
                    var defMaterialLoadId = 0;
                    var defMaterialActionId = 0;
                    if (context.props.searchParams) {
                        defMaterialLoadId = parseInt(context.props.searchParams.get("materialId")) || 0;
                        defMaterialActionId = parseInt(context.props.searchParams.get("actionId")) || 0;
                    }
                    if (defMaterialLoadId > 0) {
                        var defMaterialStatusId = parseInt(context.props.searchParams.get("statusId")) || 4000;

                        context.loadStatusBtnGrp(defMaterialStatusId);

                        context.getMaterials(defMaterialStatusId, false, function () {
                            if (context) {
                                context.loadReportCb = () => {
                                    if (defMaterialActionId) context.switchTab(defMaterialActionId.toString());

                                    //setTimeout(function () {
                                    var element = document.querySelector('.tableContainer');
                                    const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                                    if (context.props.getScroller()) context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                                    //}, 2000);
                                };
                            }
                            showDtSelID("tableMaterials", defMaterialLoadId);
                        });
                    } else {
                        context.loadStatusBtnGrp(4000);

                        context.getMaterials();

                        if (defMaterialActionId) context.switchTab(defMaterialActionId.toString());

                        /*if (defMaterialActionId == 1) {
                            $(".action-addReport:visible").click();
                        }*/
                    }

                } else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                    });
                }
            });
        });

    }

    componentDidUpdate(prevProps, prevState) {
        //console.debug("UPDATE");
        if (/*prevState.historicalReports !== this.state.historicalReports || */prevState.curStatus !== this.state.curStatus || prevState.categoryGroupKey !== this.state.categoryGroupKey || prevState.pageModels !== this.state.pageModels) {
            this.getMaterials();
        }
        else {
            var defMatCategoryGroupKey = "";
            var defMatPageModels = "";
            if (this.props.searchParams) {
                defMatCategoryGroupKey = this.props.searchParams.get("categoryGroupKey") || "";
                defMatPageModels = this.props.searchParams.get("pageModels") || "";
            }

            if (this.state.categoryGroupKey !== defMatCategoryGroupKey || this.state.pageModels !== defMatPageModels) {
                this.setState({ categoryGroupKey: defMatCategoryGroupKey, pageModels: defMatPageModels, noTable: true });
            }
        }

        //Rechargement des détails suite à switchTab (Attention : Détails pas forcément en index 1)
        if (this.state.activeTab === "1" && prevState.activeTab !== this.state.activeTab) {
            //this.loadMaterial(this.state.curMaterialId);
            var context = this;
            context.loadReportCb = () => {
                //setTimeout(function () {
                var element = document.querySelector('.tableContainer');
                if (element) {
                    const elementBottom = element.offsetTop + element.offsetHeight - 93;//marginTop - mainPanel/content
                    if (context.props.getScroller()) context.props.getScroller().smoothScroll(elementBottom /*|| 1500*/);
                }
                //}, 2000);
            };
            showDtSelID("tableMaterials", context.state.curMaterialId);
        }

        //Update Scroller Size
        if (prevState.isShowDetails && !this.state.isShowDetails) {
            if (this.props.getScroller) this.props.getScroller().update();
        }

        //Callback initCreateMaterial
        if (this.state.curMaterialId === 0 /*&& prevState.curMaterialId !== this.state.curMaterialId*/ && this.state.editionMode && !this.state.isShowDetails) {
            this.setState({ isShowDetails: true });
        }
        if (prevState.editionMode !== this.state.editionMode && this.dtFunctions && this.dtFunctions["tableMaterials"]) this.dtFunctions["tableMaterials"].setDisabled(this.state.editionMode);
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount(); 
            this.modalRoot = null;
        }
    }

    dtFunctionPanel(id, fctPanel) {
        if (!this.dtFunctions) this.dtFunctions = {};
        if (!this.dtFunctions[id]) this.dtFunctions[id] = {};
        this.dtFunctions[id] = fctPanel;
    }

    render() {
        var context = this;
        var altT = (label, args) => { return (label && label.startsWith("i18n:")) ? context.props.i18nManager.t(label.replace("i18n:", ""), args) : label };

        var listCb = function () {
            if (context.refreshCb) {
                if (context.refreshCb && typeof (context.refreshCb) === "function") { context.refreshCb(); }
                context.refreshCb = null;
            }
        };

        //TODO : createdCell >> dépendance du contexte pour éxecution de la fonction
        //TEMP : doit dépendre d'une configuration (tout virer sauf createdCell et cbInitComplete)
        var dtConfig = {
            columnDefs: [
                {
                    createdCell: (td, cellData, rowData, row, col) => {
                        var currRoot = createRoot(td);
                        currRoot.render(<Button className='btn-icon btn-simple m-0' color="dark" size="sm" disabled={this.state.editionMode}
                            onClick={() => context.loadMaterial(rowData.idMaterial, rowData)} title={context.props.i18nManager.t("gal_show")} ><i className='fa fa-eye'></i></Button>);
                    }, "targets": "renderingShow"
                },
            ],
            dtOnSelect: function (dataSel) {
                var id = dataSel.idMaterial;
                if (parseInt(id) > 0) {
                    if (!context.state.editionMode) context.loadMaterial(id, dataSel);
                }
            },
            dtOnUnselect: function (dataSel) {
                if (!context.state.editionMode) context.loadMaterial();
            },
            dtOnDblClick: function (event) {
                /*var id = parseInt(getDtSelID("lstActs"));
                var currId = parseInt($(this).closest("tr").prop("id"));
                if (currId != id) {
                    scrollToId("detailAct");
                    showDtSelID("lstActs", currId);
                }
                else {
                    if (currId > 0) {
                        scrollToId("detailAct");
                    }
                }*/
            },
            cbInitComplete: function (cRootList) {
                //Swal.close();

                /*cRootList.map((prop, elem) => {
                    console.debug(elem);
                    if (elem.classList.contains("cneedroot")) {
                        var rootElem = createRoot(elem);
                        switch (elem.getAttribute("cneedroot")) {
                            case "forceLogout":
                                rootElem.render(<button className="btn btn-primary btn-icon" onClick={() => context.forceLogout('hey!')}><i className='fa fa-edit'></i></button>);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                });*/

                //$("#report_select_filters").appendTo($(".dt-buttons").parent().parent());
                //$("#report_select_filters").removeClass("d-none").addClass("d-inline-block");

                //updateSidebar();

                listCb();
            },
            cbCustom: function () {
                listCb();
            }
        };


        var pageConfig;
        var tableConfig;
        switch (context.state.pageModels) {
            case "INFO":
                pageConfig = {
                    "objType": "model", "templates": [
                        { "title": "i18n:material.tabDetails", "objType": "template", "subType": "MATERIAL_INFO", "checkRights": { "entity": "MATERIAL", "rights": "R" } },
                        { "title": "i18n:material.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "MATERIAL_CONTACTS", "rights": "L" } },
                        { "title": "i18n:material.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "MATERIAL_FILES", "rights": "L" } },
                        { "title": "i18n:material.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "MATERIAL_FLOWS", "rights": "L" } },
                        { "title": "i18n:material.add", "objType": "button", "subType": "ADD", "checkRights": { "entity": "MATERIAL", "rights": "C" } }
                    ]
                };
                tableConfig = "DT_INFOMATERIALS";
                break;
            case "WIDGETMAT":
                pageConfig = {
                    "objType": "model", "templates": [
                        { "title": "i18n:material.tabDetails", "objType": "template", "subType": "MATERIAL_INFO", "checkRights": { "entity": "MATERIAL", "rights": "R" } },
                        { "title": "i18n:material.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "MATERIAL_CONTACTS", "rights": "L" } },
                        { "title": "i18n:material.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "MATERIAL_FILES", "rights": "L" } },
                        { "title": "i18n:material.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "MATERIAL_FLOWS", "rights": "L" } },
                        { "title": "i18n:material.add", "objType": "button", "subType": "ADD", "checkRights": { "entity": "MATERIAL", "rights": "C" } },
                        { "title": "i18n:material.add0", "objType": "widgetList", "subType": "ADD", "checkRights": { "entity": "MATERIAL", "rights": "C" }, "name": "i18n:material.add1", "tag": "i18n:material.add2" }
                    ]
                };
                tableConfig = "DT_MATERIALS";
                break;
            default:
                pageConfig = {
                    "objType": "model", "templates": [
                        { "title": "i18n:material.tabDetails", "objType": "template", "subType": "MATERIAL", "checkRights": { "entity": "MATERIAL", "rights": "R" } },
                        { "title": "i18n:material.tabContacts", "objType": "template", "subType": "CONTACTS", "checkRights": { "entity": "MATERIAL_CONTACTS", "rights": "L" } },
                        { "title": "i18n:material.tabDocs", "objType": "template", "subType": "FILES", "checkRights": { "entity": "MATERIAL_FILES", "rights": "L" } },
                        { "title": "i18n:material.tabFlows", "objType": "template", "subType": "FLOWS", "checkRights": { "entity": "MATERIAL_FLOWS", "rights": "L" } },
                        { "title": "i18n:material.add", "objType": "button", "subType": "ADD", "checkRights": { "entity": "MATERIAL", "rights": "C" } }
                    ]
                };
                tableConfig = "DT_MATERIALS";
                break;
        }



        var getSysCpt = (template, index) => {
            var curUser = this.props.getUser();

            var srcRoles = curUser.roles;
            var haveCustomProfiles = curUser.roles.filter(role => role.startsWith("PRFL_"));
            srcRoles = haveCustomProfiles?.length ? haveCustomProfiles : srcRoles;
            var targetRoles = srcRoles ? srcRoles[0] : null;

            var materialModel;
            var srcModel;
            var resFilter = Object.keys(this.materialModels).filter((key) => {
                var model = this.materialModels[key];
                if (key === "MATERIAL" || key === ("MATERIAL_" + this.state.curMaterial?.categoryID)) {
                    if (model.siteID > 0 || (model.siteID === -1 && !srcModel)) {
                        srcModel = model;
                    }
                }

                return key === "MATERIAL_" + targetRoles || (key === ("MATERIAL_" + this.state.curMaterial?.categoryID + "_") + targetRoles);
            });
            if (resFilter?.length) {
                materialModel = this.materialModels[resFilter[0]];
            }
            else if (srcModel) {
                materialModel = srcModel;
            }
            else {
                materialModel = this.materialModels ? (this.materialModels["MATERIAL_" + this.state.curMaterial?.categoryID] || this.materialModels[template.subType]) : {};
            }

            var filesAltObj = {};
            if (context.filesType) filesAltObj.filesType = context.filesType;
            else filesAltObj.altFilesTypes = "../api/material/GetMaterialFilesType";

            var cptSysCollection = {
                "MATERIAL": <ShowDetails id={this.state.curMaterialId} type="material" genRef={this.materialGen} data={this.state.curMaterial} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={materialModel} modelsList={this.materialModels} loadElem={this.loadMaterial.bind(this)} saveElem={this.contextSaveMaterial.bind(this)} removeElem={this.removeMaterial.bind(this)} updateStatusElem={this.updateMaterialStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === index.toString()} />,
                "MATERIAL_INFO": <ShowDetails id={this.state.curMaterialId} type="material" genRef={this.materialGen} data={this.state.curMaterial} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={materialModel} modelsList={this.materialModels} loadElem={this.loadMaterial.bind(this)} saveElem={this.contextSaveMaterial.bind(this)} removeElem={this.removeMaterial.bind(this)} updateStatusElem={this.updateMaterialStatus.bind(this)} setEditingMode={this.setEditingMode.bind(this)} formEditing={this.state.editionMode} shouldRender={this.state.activeTab === index.toString()} manageBackMatTicket={this.manageBackMatTicket.bind(this)} />,
                "CONTACTS": <ShowDetails id={this.state.curMaterialId} type="materialContacts" data={this.state.curMaterial} dataCfg={this.props.dataCfg} appProps={this.props} checkRights={this.props.checkRights} getRoutes={this.props.getRoutes} noButtons configModel={this.materialModels ? this.materialModels["CONTACTS"] : {}} modelsList={this.materialModels} shouldRender={this.state.activeTab === index.toString()} />,
                "FILES": <Form id="frmaupdact3">
                    <FilesCustom className="material-files" bindID={this.state.curMaterialId} rightType={template?.checkRights?.entity} checkRights={this.props.checkRights} fileTypeID="MATERIAL" src={this.state.curMaterial}
                        srcName={this.state.curMaterial ? this.state.curMaterial.title : ""} withFilters={true} shouldRender={this.state.activeTab === index.toString()} defaultFileType={"TEC"}
                        altFilesTypes="../api/material/GetMaterialFilesType" altFilesUrl="../api/material/GetMaterialFiles" altRemoveFilesUrl="../api/material/RemoveMaterialFile" altUploadFilesUrl="../api/material/UploadMaterialFiles" />
                </Form>,
                "FLOWS": <Row className="material-history">
                    <Col lg="12">
                        <Card className="widget dash">
                            <CardHeader>
                                <CardTitle tag="h6">{context.props.i18nManager.t("material.flowsTitle")}</CardTitle>
                                <div className="widget-tools collapse-tool">
                                    <i className="fa fa-history fa-4x"></i>
                                </div>
                                <div className='borderTheme'></div>
                            </CardHeader>
                            <CardBody>
                                <Historical type="material" elemId={context.state.curMaterialId} rows={context.state.curMaterial?.flows} url="../api/material/GetMaterialFlows" getRoutes={context.props.getRoutes} shouldRender={context.state.activeTab === index.toString()} />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>,
            };

            return <TabPane key={"tabpane" + template.subType + index} tabId={index.toString()}>{this.props.checkRights(template?.checkRights?.entity, template?.checkRights?.rights) ? cptSysCollection[template.subType] : ""}</TabPane>;
        };

        //console.debug("render again");

        var validMaterials = this.state.materials.filter(material => {
            return !(material.idMaterial <= 0);
        });
        var filteredMaterials = validMaterials.filter(material => {
            if (context.state.assignSiteFilter > 0 && material.assignSiteID !== context.state.assignSiteFilter) return false;
            if (context.state.serviceFilter > 0 && material.serviceID !== context.state.serviceFilter) return false;
            if (context.state.groupFilter > 0 && material.groupID !== context.state.groupFilter) return false;

            var searchProc = (field, searchField) => {
                var editField = field.trim().replaceAll(" ", "").toLowerCase();
                editField = editField
                    .replace(/έ/g, 'ε')
                    .replace(/[ύϋΰ]/g, 'υ')
                    .replace(/ώ/g, 'ω')
                    .replace(/ά/g, 'α')
                    .replace(/[ίϊΐ]/g, 'ι')
                    .replace(/ή/g, 'η')
                    .replace(/\n/g, ' ')
                    .replace(/á/g, 'a')
                    .replace(/â/g, 'a')
                    .replace(/ã/g, 'a')
                    .replace(/é/g, 'e')
                    .replace(/ê/g, 'e')
                    .replace(/ë/g, 'e')
                    .replace(/è/g, 'e')
                    .replace(/í/g, 'i')
                    .replace(/î/g, 'i')
                    .replace(/ï/g, 'i')
                    .replace(/ì/g, 'i')
                    .replace(/ó/g, 'o')
                    .replace(/ô/g, 'o')
                    .replace(/õ/g, 'o')
                    .replace(/ό/g, 'ο')
                    .replace(/ú/g, 'u')
                    .replace(/ü/g, 'u')
                    .replace(/ç/g, 'c');
                var editSearchField = searchField || (context.state.searchField?.trim()/*.replaceAll(" ", "")*/.toLowerCase()
                    .replace(/έ/g, 'ε')
                    .replace(/[ύϋΰ]/g, 'υ')
                    .replace(/ώ/g, 'ω')
                    .replace(/ά/g, 'α')
                    .replace(/[ίϊΐ]/g, 'ι')
                    .replace(/ή/g, 'η')
                    .replace(/\n/g, ' ')
                    .replace(/á/g, 'a')
                    .replace(/â/g, 'a')
                    .replace(/ã/g, 'a')
                    .replace(/é/g, 'e')
                    .replace(/ê/g, 'e')
                    .replace(/ë/g, 'e')
                    .replace(/è/g, 'e')
                    .replace(/í/g, 'i')
                    .replace(/î/g, 'i')
                    .replace(/ï/g, 'i')
                    .replace(/ì/g, 'i')
                    .replace(/ó/g, 'o')
                    .replace(/ô/g, 'o')
                    .replace(/õ/g, 'o')
                    .replace(/ό/g, 'ο')
                    .replace(/ú/g, 'u')
                    .replace(/ü/g, 'u')
                    .replace(/ç/g, 'c'));

                var splitField = editSearchField?.split(" ");
                if (splitField?.length > 1) {
                    var flag = true;
                    splitField.forEach(subField => {
                        flag &= searchProc(field, subField);
                    });
                    return flag;
                }
                else return editField.indexOf(editSearchField) >= 0;

                //return editField.indexOf(editSearchField) >= 0;
            };

            if (context.state.searchField && !(searchProc(material.title) || searchProc(material.client?.name) || searchProc(material.client?.firstName) || searchProc(material.client?.name + " " + material.client?.firstName) || searchProc(material.tel) || searchProc(material.status?.name))) return false;
            return true;
        }).sort((a, b) => {
            if (a.priority !== b.priority) {
                return b.priority - a.priority;
            }
            /*else if (a.priority && b.priority) {
                return moment(a.dSysMod).diff(b.dSysMod, "seconds");
            }*/
            return moment(b.dSysMod).diff(a.dSysMod, "seconds");
        });

        var templatesWidgetList = pageConfig?.templates?.filter(template => template.objType === "widgetList");
        if (/*!context.state.switchDisplay &&*/ templatesWidgetList.length > 0) {
            try {
                if (context.state.pageModels === "WIDGETMAT") {
                    return this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
                        <div className="oskala-material">
                            {/* ==========================================
                                TOOLBAR
                                ========================================== */}
                            <div className="materials-toolbar">
                                <div className="materials-toolbar-left">
                                    {/* Actualiser */}
                                    <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" onClick={() => this.getMaterials()}>
                                        <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                                    </Button>

                                    {/* Nouveau ??? */}
                                    {pageConfig?.templates?.map((template, index) => {
                                        if (template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                            switch (template.subType) {
                                                case "ADD":
                                                    return <Button key={"addbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" onClick={() => this.initCreateMaterial()}>
                                                        <i className="fa fa-plus-square fa-lg"></i>{context.props.i18nManager.t("material.add")}
                                                    </Button>;
                                                case "DIALOGADD":
                                                    var saveCb = (materialResponse) => {
                                                        context.getMaterials(3000, true, () => { });
                                                    };
                                                    return <Button key={"dialogaddbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" onClick={() => showDialogMaterial(altT(template.name), template.tag, null, context.materialModels, saveMaterial, saveCb, context.modalGenManager, context.props, context.props.i18nManager)}>
                                                        <i className="fa fa-user-plus fa-lg"></i>{context.props.i18nManager.t("material.add")}
                                                    </Button>;
                                                default: return "";
                                            }
                                        }
                                        else return "";
                                    })}

                                    {/* Compteur */}
                                    <span className="materials-results-count">
                                        <strong>{filteredMaterials.length}</strong> élément(s)
                                        {(validMaterials.length - filteredMaterials.length) > 0 && ` (filtré de ${validMaterials.length} au total)`}
                                    </span>
                                </div>

                                <div className="materials-toolbar-right">
                                    {/* Recherche */}
                                    <Label className="materials-filter-label" for="inputSearch">{context.props.i18nManager.t("material.inputSearchFilter")}</Label>
                                    <Input id={"inputSearch"} bsSize="sm" className="materials-filter-select" placeholder={context.props.i18nManager.t("material.inputSearchHolder")} type="text" autoComplete="off" aria-autocomplete="none" onChange={(e) => {
                                        context.setState({ searchField: e.target.value });
                                    }} />

                                    {/* Expand / Collapse */}
                                    <div className="expand-collapse-group">
                                        <button
                                            className={`btn-expand-all ${context.state.expandAll === true ? 'active' : ''}`}
                                            onClick={() => {
                                                context.setState({ expandAll: true, expandStamp: Date.now() });
                                            }}
                                        >
                                            <i className="fas fa-expand-alt"></i> Tout déplier
                                        </button>
                                        <button
                                            className={`btn-collapse-all ${context.state.expandAll !== true ? 'active' : ''}`}
                                            onClick={() => {
                                                context.setState({ expandAll: false, expandStamp: Date.now() });
                                            }}
                                        >
                                            <i className="fas fa-compress-alt"></i> Tout replier
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="materials-group">
                                {filteredMaterials.map(material => {

                                    var statusOrder = [3001, 3002, 3003, 3004, 3097, 3005, 3006, 3007];

                                    try {
                                        return <CardMat
                                            key={`material-${material.idMaterial}`}
                                            material={material}
                                            context={context}
                                            t={context.props.i18nManager.t} altT={altT}
                                            templatesWidgetList={templatesWidgetList}
                                            statusOrder={statusOrder}
                                            expandAll={this.state.expandAll}
                                            expandStamp={this.state.expandStamp}
                                        />;
                                    }
                                    catch (e) {
                                        console.error(e);
                                        return <div key={"materialerror" + material.idMaterial} className="badge badge-danger my-3">Une erreur est survenu lors du chargement de ce widget {"- " + material.idMaterial + " " + material.client?.name + " - " + material.service?.name}</div>
                                    }
                                })}
                            </div>
                        </div>;


                }
                else {
                    return "";
                }
            }
            catch (e) {
                console.error(e);
                return <div>Une erreur est survenu lors du chargement de la liste widget</div>
            }
        }
        else {
            let contents = this.state.loading ? <p><em>{context.props.i18nManager.t("gal_loading")}</em></p> :
                <div>
                    {this.materialModels && !this.state.noTable ? <CDataTable key="materials" dtId={"tableMaterials"} data={this.state.materials} localConfig={dtConfig} tag={tableConfig} config={this.materialModels[tableConfig]} stamp={this.state.dataStamp} functionPanel={this.dtFunctionPanel.bind(this)}
                        className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} /> : ""}
                </div>;

            return (
                <div className="tableDetails">
                    <Card className={`tableContainer widget dash ${this.state.editionMode ? "module-disabled" : ""}`}>
                        <CardHeader>
                            <CardTitle tag="h6">{context.props.i18nManager.t("material.title")}</CardTitle>
                            <div className="widget-tools collapse-tool">
                                <i className="fa fa-table-list fa-4x"></i>
                            </div>
                            <div className='borderTheme'></div>
                        </CardHeader>
                        <CardBody>
                            <div className="float-start">
                                <Button className="btn-rotate px-2 btn-simple mt-0" disabled={this.state.editionMode} color="dark" size="sm" onClick={() => this.getMaterials()}>
                                    <i className="fa fa-sync"></i>{context.props.i18nManager.t("gal_refresh")}
                                </Button>
                                {pageConfig?.templates?.map((template, index) => {
                                    if (template.objType === "button" && this.props.checkRights(template.checkRights?.entity, template.checkRights.rights)) {
                                        switch (template.subType) {
                                            case "ADD":
                                                return <Button key={"addbtn"} className="btn-magnify px-2 mt-0" disabled={this.state.editionMode} color="success" size="sm" onClick={() => this.initCreateMaterial()}>
                                                    <i className="fa fa-plus-square fa-lg"></i>{context.props.i18nManager.t("material.add")}
                                                </Button>;
                                            default: return "";
                                        }
                                    }
                                    else return "";
                                })}
                            </div>
                            <CNavbar className="float-end">
                                <div className="text-end">
                                    {this.state.status.map((dt) => {

                                        //TODO : statusBtnAltProc

                                        var statusClass = "form-badge-radio mb-1 ";
                                        statusClass += dt.css ? dt.css.replace("fa-", "untrigger") : "";
                                        return dt.isSchedulable ? <div id={`st_${dt.idStatus}`} key={dt.idStatus} className={statusClass}>
                                            <div className='form-check-radio fcheck-sm mb-0'>
                                                <Label check >
                                                    <Input id={`status_${dt.idStatus}`} name={"status"} disabled={this.state.editionMode} checked={dt.idStatus === context.state.curStatus} type="radio" data-lvlv={dt.step} value={dt.idStatus} onChange={(e) => {
                                                        var value = parseInt(e.target.value);

                                                        context.setState({ curStatus: value, curMaterialId: 0, curMaterial: null, isShowDetails: false });
                                                    }} />
                                                    <span className="form-check-sign" />
                                                    {(() => {
                                                        var classFa = "";
                                                        if (dt.css && dt.css.indexOf("fa-")) {
                                                            dt.css.split(" ").forEach((classElem) => {
                                                                //console.debug(classElem.startsWith("fa-") + classElem);
                                                                classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                                            });
                                                        }
                                                        return <i className={`fa ${classFa} me-1`}></i>
                                                    })()}
                                                    {altT(dt.name)}
                                                </Label>
                                            </div>
                                        </div> : "";
                                    })}
                                </div>
                            </CNavbar>
                            {contents}
                        </CardBody>
                    </Card>

                    {this.state.isShowDetails ? (<div className="detailsContainer">
                        <Card className="widget dash text-white" color="theme">
                            <CardHeader>
                                <Row>
                                    <Col lg="10" className="offset-lg-1">
                                        <CardTitle tag="h6" className="text-center">
                                            {this.state.title}
                                        </CardTitle>
                                    </Col>
                                    <Col lg="1" className="d-flex text-end float-end justify-content-end">
                                        <Button className="btn btn-icon my-0 text-dark" color="light" id="selActPrev" type="button" disabled={this.state.editionMode} onClick={() => {
                                            var prevId = context.state.curMaterialId || 0;
                                            showDtPrevID("tableMaterials", prevId);
                                        }}><i aria-hidden="true" className="fa fa-arrow-circle-left"></i></Button>
                                        <Button className="btn btn-icon my-0 text-dark" color="light" id="selActNext" type="button" disabled={this.state.editionMode} onClick={() => {
                                            var prevId = context.state.curMaterialId || 0;
                                            showDtNextID("tableMaterials", prevId);
                                        }}><i aria-hidden="true" className="fa fa-arrow-circle-right"></i></Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Nav pills className={`${this.state.editionMode ? "invisible" : ""}`}>
                                    {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => (this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? <NavItem key={"navItem" + index}><NavLink className={`${this.state.activeTab === (index + 1).toString() ? "active" : ""}`} onClick={() => { this.switchTab((index + 1).toString()) }}>{altT(template.title)}</NavLink></NavItem> : ""))}
                                </Nav>
                            </CardBody>
                        </Card>
                        <TabContent activeTab={this.state.activeTab}>
                            {pageConfig?.templates?.filter(template => template.objType === "template").map((template, index) => this.props.checkRights(template.checkRights?.entity, template.checkRights.rights) ? getSysCpt(template, index + 1) : "")}
                        </TabContent></div>) : ""}
                </div>
            );
        }
    }

    async getMaterials(statusId, forcedUpdate, callback) {
        if (!forcedUpdate && this.state.editionMode) return;
        this.setState({ materials: [], curMaterialId: 0, curMaterial: null/*, loading: true*/, dataStamp: 0, isShowDetails: false, editionMode: false, noTable: false });
        var context = this;

        if (callback) {
            context.refreshCb = callback;
        }

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = {};
        args.state = statusId || this.state.curStatus || 4000;
        if (context.state.pageModels === "INFO") {
            args.level = 5;
        }
        else args.level = 1;


        if (context.state.categoryGroupKey) args.categoryGroupKey = context.state.categoryGroupKey;

        commonFunc.getMethod("../api/material/GetMaterials", args).then((response) => {
            if (response.data) {
                if (response.data.isSuccess) {
                    Swal.close();
                    context.setState({ materials: response.data.result, loading: false, dataStamp: new Date().getTime(), isShowDetails: false });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_error"),
                        html: context.props.i18nManager.t("material.failLoadMaterials") + " :<br>" + response.data.errorMessage
                    });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_error"),
                    html: context.props.i18nManager.t("material.failLoadMaterials")
                });
            }
        });

    }

    loadStatusBtnGrp(defaultID) {
        var context = this;

        commonFunc.getMethod("../api/material/GetStatus", null).then((response) => {
            var data = response.data;

            //Libelle = name + ForeColor = foreColor + Opacite >> removed + Niveau = step + Categ = categ + Actif = isActive + Planifiable = isSchedulable + css + valeur = value
            if (data.isSuccess) {

                context.setState({ status: data.result, defaultStatus: defaultID });

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadStatus") + "<br/>" + response.data.errorMessage
                });
            }

        });
    }

    async loadMaterial(id) {
        var context = this;

        var callback = this.loadReportCb;

        this.setState({ title: context.props.i18nManager.t("material.noSelected"), curMaterialId: 0, curMaterial: null, isShowDetails: (id > 0), editionMode: false });

        return new Promise((resolve, reject) => {

            var args = {};
            //args.state = 201;
            args.id = id;

            if (context.state.pageModels === "INFO") {
                args.level = 3;
            }
            if (parseInt(id) > 0) {
                this.loadReportCb = null;
                Swal.fire({
                    title: context.props.i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false
                });

                commonFunc.getMethod("../api/material/GetMaterial", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {
                        console.log(data.result);

                        if (callback && typeof (callback) === "function") { callback(data); }

                        Swal.close();

                        if (context.state.isShowDetails) context.setState({ title: ("[" + (data.result.category ? data.result.category.name : "") + "] " + data.result.name + " • " + data.result.model), curMaterialId: id, curMaterial: data.result, isShowDetails: true });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: context.props.i18nManager.t("gal_error"),
                            html: context.props.i18nManager.t("material.failLoadMaterial") + " :<br>" + data.errorMessage
                        });
                    }
                    resolve(data);
                });

            }
            else {
                resolve({ isSuccess: true, result: "" });
            }
        });
    }

    async contextSaveMaterial(userMaterial, isUpdate) {
        var context = this;

        return saveMaterial(userMaterial, context.state.curMaterial, isUpdate, { translation: context.props.i18nManager.t }).then((materialResponse) => {
            context.loadMaterial(materialResponse.idMaterial);//userMaterial.idMaterial

            return new Promise((resolve, reject) => {
                resolve(materialResponse);
            });
        });
    }

    removeMaterial(id, title) {
        var context = this;
        return new Promise((resolve, reject) => {
            var row = context.state.curMaterial;
            if ((!id && row) || (id && row && id === row.idMaterial)) {
                id = id || row.idMaterial;
                title = row.name;
            }
            if (parseInt(id) > 0) {
                Swal.fire({
                    icon: "question",
                    title: context.props.i18nManager.t("gal_removing"),
                    html: context.props.i18nManager.t("material.rmvTitle") + "<br/>[" + id + "] " + title,
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: context.props.i18nManager.t("gal_yes"),
                    cancelButtonText: context.props.i18nManager.t("gal_no"),
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: context.props.i18nManager.t("material.removing"),
                            didOpen: () => { Swal.showLoading() }
                        });
                        var req = { id: id, isPermanent: false };
                        commonFunc.postMethod("../api/material/RemoveMaterial", req).then((response) => {
                            Swal.close();
                            var data = response.data;
                            if (data && data.isSuccess) {
                                context.getMaterials();//TODO : check si besoin de refresh supplémentaire
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                });
                            }
                            resolve(data);
                        });

                    }
                    else {
                        resolve({ isSuccess: true, result: "" });
                    }
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }


    updateMaterialStatus(statusId, stepId, customLabel, reloadMaterial, noSwal) {
        var context = this;
        return new Promise((resolve, reject) => {
            var id = context.state.curMaterialId;
            if (parseInt(id) > 0) {
                if (statusId > 0) {
                    var label = "";
                    reloadMaterial = (reloadMaterial === false ? false : true);

                    var curStatus = context.state.status.filter((status) => status.idStatus === statusId);
                    label = customLabel || (curStatus.length ? curStatus[0].name : "");


                    var statusProc = () => {
                        Swal.fire({
                            title: context.props.i18nManager.t("material.updatingStatus"),
                            didOpen: () => { Swal.showLoading() },
                        });
                        var req = { id: id, newStatus: statusId, newStep: stepId || -1 };

                        commonFunc.postMethod("../api/material/UpdateStatus", req).then((response) => {

                            Swal.close();
                            if (response.data && response.data.isSuccess) {
                                /*context.getMaterials(0, true, () => {
                                    if (reloadMaterial) showDtSelID("tableMaterials", id);
                                });*///TODO : check si besoin de refresh supplémentaire
                                if (reloadMaterial) context.loadMaterial(id);
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_fail"),
                                    html: context.props.i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                                });
                            }
                            resolve(response.data);
                        });
                    };

                    if (noSwal) {
                        statusProc();
                    }
                    else {
                        Swal.fire({
                            icon: "question",
                            title: context.props.i18nManager.t("material.updStatus"),
                            html: context.props.i18nManager.t("material.statusAs", [label]),
                            showCancelButton: true,
                            confirmButtonColor: "#28a745",
                            cancelButtonColor: "#dc3545",
                            confirmButtonText: context.props.i18nManager.t("gal_yes"),
                            cancelButtonText: context.props.i18nManager.t("gal_no"),
                        }).then((result) => {
                            if (result.value) {
                                statusProc();
                            }
                            else {
                                resolve({ isSuccess: true, result: "" });
                            }
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_invalidStatus")
                    });
                    resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_invalidStatus") });
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_noSelectedElem")
                });
                resolve({ isSuccess: false, result: context.props.i18nManager.t("gal_noSelectedElem") });
            }
        });
    }

    manageBackMatTicket(statusID, stepID, defaultAssign, defaultTicket, altMode) {
        var context = this;
        var altMaterial = Object.assign({}, this.state.curMaterial);

        //Vérification présence assignment matériel
        var mtnAssign = altMaterial.materialAssigns?.filter(assign => assign.service?.refExtID === "608" && assign.statusExt === "EC" && assign.endDate === "2099-12-31");

        var swalSuccess = () => {
            Swal.fire({
                icon: "success",
                title: context.props.i18nManager.t("gal_success"),
                html: context.props.i18nManager.t("gal_successUpd"),
                didOpen: () => { Swal.hideLoading() },
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                timer: 2000,
            }).then(() => {
                context.loadMaterial(altMaterial.idMaterial);//userMaterial.idMaterial
            });
        };

        //Restauration parc
        if (!defaultAssign && !defaultTicket) {
            if (mtnAssign?.length) {
                mtnAssign[0].endDate = new Date().toISOString().substring(0, 10);
                mtnAssign[0].statusExt = "KO";
            }

            if (altMode?.startsWith("clear")) {
                var split = altMode.split(":");
                altMaterial.cAssignments = true;
                altMaterial.assignEmployeeID = -1;//null
                altMaterial.assignSiteID = (split.length > 1 ? parseInt(split[1]) : -1);//null
                /*if (mtnAssign.length <= 0) {
                    Swal.fire({
                        icon: "warning",
                        title: context.props.i18nManager.t("gal_warning"),
                        html: "Aucune assignation maintenance est en cours"
                    });
                    return;
                }*/
            }

            altMaterial.statusID = statusID;
            altMaterial.stepID = stepID;

            saveMaterial(altMaterial, context.state.curMaterial, true, { translation: context.props.i18nManager.t, noSwal: true }).then((responseMaterial) => {
                if (responseMaterial?.idResponse) {
                    //Clôture du ticket
                    if (mtnAssign?.length) {
                        var args = {};
                        args.state = 7000;
                        args.materialID = altMaterial.idMaterial;
                        //args.level = 3;

                        commonFunc.getMethod("../api/ticket/GetTickets", args).then((response) => {
                            var data = response.data;
                            if (data.isSuccess) {
                                console.log(data.result);

                                var currentTickets = data.result.filter(ticket => ticket.status.step < 3 && ticket.extRef === "MATMTN-" + mtnAssign[0].idAssign);
                                if (currentTickets?.length) {
                                    console.debug(currentTickets);
                                    //MAJ Ticket Associé
                                    var backTicket = currentTickets[0];
                                    backTicket.endDate = new Date().toISOString();
                                    backTicket.closeComments = "Clôture via restitution manuelle depuis matériel";

                                    saveTicket(backTicket, null, true, { translation: context.props.i18nManager.t, noSwal: true }).then(responseTicket => {
                                        if (responseTicket?.idResponse) {
                                            console.debug("ISOK");
                                            var req = { id: backTicket.idTicket, newStatus: 7003, newStep: -1 };
                                            commonFunc.postMethod("../api/ticket/UpdateStatus", req).then((response) => {
                                                swalSuccess();
                                            });
                                        }
                                    });
                                }
                                else {
                                    swalSuccess();
                                }
                                Swal.close();
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: context.props.i18nManager.t("gal_error"),
                                    html: context.props.i18nManager.t("material.failLoadMaterial") + " :<br>" + data.errorMessage
                                });
                            }
                        });
                    }
                    else {
                        swalSuccess();
                    }
                }
            });
        }
        //Retour pour maintenance
        else {
            if (mtnAssign?.length) {
                Swal.fire({
                    icon: "warning",
                    title: context.props.i18nManager.t("gal_warning"),
                    html: "Une assignation maintenance est en cours"
                });
                return;
            }

            //Gestion Assignment
            var newAssign = defaultAssign || {};
            newAssign.startDate = new Date().toISOString().substring(0, 10);
            newAssign.assignEmployeeID = -1; //altMaterial.assignEmployeeID;
            newAssign.siteID = altMaterial.assignSiteID;

            if (!altMaterial.materialAssigns) altMaterial.materialAssigns = [];
            altMaterial.materialAssigns.push(newAssign);

            altMaterial.statusID = statusID;
            altMaterial.stepID = stepID;

            saveMaterial(altMaterial, context.state.curMaterial, true, { translation: context.props.i18nManager.t, noSwal: true }).then((responseMaterial) => {
                console.debug(responseMaterial);
                if (responseMaterial?.idResponse) {

                    //Récupération Assignation créé
                    var refExtID = 0;
                    var filteredMtnActive = responseMaterial.materialAssigns?.filter(assign => assign.serviceID === 608 && assign.statusExt === "EC" && assign.endDate === "2099-12-31");//pas de retour service?.refExtID du response
                    if (filteredMtnActive?.length) {
                        refExtID = filteredMtnActive[0].idAssign;
                    }

                    //Création Ticket Associé
                    var backTicket = defaultTicket || {};
                    //backTicket.address = { addressMain: "N/A", categ: "SITE", title: "Adresse" };//TODO : Adresse du site ?
                    backTicket.startDate = new Date().toISOString();
                    backTicket.extRef = "MATMTN-" + refExtID;
                    backTicket.title = "Retour Matériel - " + altMaterial.name;
                    backTicket.assignMaterialID = altMaterial.idMaterial;
                    backTicket.assignEmployeeID = -1;//altMaterial.assignEmployeeID
                    backTicket.assignSiteID = altMaterial.assignSiteID;
                    backTicket.comments = "Retour Fédé. - " + (altMaterial.intRef || "N/A") + " / " + (altMaterial.serialNumber || "N/A");

                    saveTicket(backTicket, null, false, { translation: context.props.i18nManager.t, noSwal: true }).then(responseTicket => {
                        if (responseTicket?.idResponse) {
                            console.debug("ISOK");
                            swalSuccess();
                        }
                        else {
                            //TODO : remove Assign + change status ??
                        }
                    });
                }
            });
        }
    }

    initCreateMaterial() {
        if (this.state.editionMode) return;
        setDtNoSelect("tableMaterials");
        //this.materialGen.current.resetForm();
        this.setState({ title: this.props.i18nManager.t("material.create"), curMaterialId: 0, curMaterial: null, isShowDetails: false, editionMode: true, activeTab: "1" });
    }

    switchTab(numTab, entity) {
        if (this.state.editionMode) return;
        var supStates = {};
        if (numTab === "1") supStates.isShowDetails = false;
        this.setState({ activeTab: numTab, ...supStates });
    }

    setEditingMode(value, isDuplicate) {
        var title = this.state.curMaterial ? this.state.curMaterial.title : "";
        this.setState({ title: (isDuplicate ? this.props.i18nManager.t("material.duplicate") : this.props.i18nManager.t("material.edit")) + " - " + title, editionMode: value });
    }
}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageMaterials));

        

export async function saveMaterial(userMaterial, dataMaterial, isUpdate, args) {
    dataMaterial = dataMaterial || {};

    Swal.fire({
        title: args.translation("gal_saving"),
        didOpen: () => { Swal.showLoading() },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
    });

    try {
        if (!userMaterial.avoidMerge) {
            userMaterial = commonFunc.mergeDeep({}, dataMaterial, userMaterial);

            userMaterial.accountUser = null;
            userMaterial.category = null;
            userMaterial.parent = null;
            userMaterial.client = null;
            userMaterial.report = null;
            userMaterial.manager = null;
            userMaterial.employee = null;
            userMaterial.provider = null;
            userMaterial.group = null;
            userMaterial.site = null;
            userMaterial.extSite = null;
            userMaterial.extraSite = null;
            userMaterial.status = null;
            userMaterial.subStatus = null;
            userMaterial.tenantUserAccess = null;
        }

        if (userMaterial.materialAssigns?.length) {
            userMaterial.materialAssigns.forEach(assign => {
                assign.client = null;
                assign.employee = null;
                assign.service = null;
                assign.site = null;
            });
        }

        var manageAssign = userMaterial.idMaterial === 0;
        if (userMaterial.cAssignments) {
            //Gestion Assignment Employee
            if (userMaterial.assignEmployeeID !== dataMaterial.assignEmployeeID) {
                manageAssign = true;
            }
            //Gestion Assignment Agence
            if (userMaterial.assignSiteID !== dataMaterial.assignSiteID) {
                manageAssign = true;
            }

            if (manageAssign) {
                if (userMaterial.idMaterial > 0) {
                    //userMaterial.materialAssigns = null;
                    if (userMaterial.materialAssigns?.length) {
                        var filteredAssigns = userMaterial.materialAssigns.filter(assign => assign.serviceID === -1 && assign.statusExt === "OK" && assign.endDate === "2099-12-31").sort((a, b) => {
                            return moment(a.endDate).diff(b.endDate, "days");
                        });

                        if (filteredAssigns?.length) {
                            filteredAssigns[0].endDate = new Date().toISOString().substring(0, 10);
                            filteredAssigns[0].statusExt = "FIN";
                        }
                    }

                    var newAssign = {};
                    newAssign.idAssign = 0;
                    newAssign.parentID = null;
                    newAssign.materialID = userMaterial.idMaterial;
                    newAssign.material = null;
                    newAssign.title = "Assignation Matériel";
                    newAssign.startDate = new Date().toISOString().substring(0, 10);
                    newAssign.endDate = "2099-12-31T00:00:00.000Z".substring(0, 10);
                    newAssign.statusExt = "OK";
                    newAssign.assignEmployeeID = userMaterial.assignEmployeeID;
                    newAssign.employee = null;
                    newAssign.siteID = userMaterial.assignSiteID;
                    newAssign.site = null;

                    if (!userMaterial.materialAssigns) userMaterial.materialAssigns = [];
                    userMaterial.materialAssigns.push(newAssign);
                }
                else {
                    var newAssign = {};
                    newAssign.idAssign = 0;
                    newAssign.parentID = null;
                    newAssign.materialID = 0;
                    newAssign.material = null;
                    newAssign.title = "Assignation Matériel";
                    newAssign.startDate = new Date().toISOString().substring(0, 10);
                    newAssign.endDate = "2099-12-31T00:00:00.000Z".substring(0, 10);
                    newAssign.statusExt = "OK";
                    newAssign.assignEmployeeID = userMaterial.assignEmployeeID;
                    newAssign.employee = null;
                    newAssign.siteID = userMaterial.assignSiteID;
                    newAssign.site = null;

                    if (!userMaterial.materialAssigns) userMaterial.materialAssigns = [];
                    userMaterial.materialAssigns.push(newAssign);
                }
            }
        }

        console.debug(userMaterial);
        //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
        return commonFunc.postMethod(isUpdate ? "../api/material/UpdateMaterial" : "../api/material/CreateMaterial", userMaterial).then((response) => {
            Swal.close();
            return new Promise((resolve, reject) => {
                var data = response.data;
                if (data && data.isSuccess) {

                    var nextProc = () => {
                        /*if (context.state.curStatus !== data.result.statusID) {
                            context.setState({ curStatus: data.result.statusID });
                            context.refreshCb = () => {
                                showDtSelID("tableMaterials", data.result.idMaterial);
                            };
                        }
                        else {
                            context.getMaterials(0, true, () => {
                                showDtSelID("tableMaterials", data.result.idMaterial);
                            });
                        }*/

                        data.result.idResponse = data.result.idMaterial;
                        resolve(data.result);
                    };


                    if (args.noSwal) {
                        nextProc();
                    }
                    else {
                        Swal.fire({
                            icon: "success",
                            title: args.translation("gal_success"),
                            html: (isUpdate ? args.translation("gal_successUpd") : args.translation("gal_successAdd")),
                            didOpen: () => { Swal.hideLoading() },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                        }).then((result) => {
                            nextProc();
                        });
                    }

                } else {
                    var supErrors = "";
                    if (data.errors && data.errors.length) {
                        supErrors = data.errors.map((error) => {
                            return "<br>" + error.desc + "(" + error.value + ")";
                        });
                    }
                    Swal.fire({
                        icon: "error",
                        title: args.translation("gal_fail"),
                        html: args.translation("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                    });
                    resolve(data);
                }
            });
        });

    }
    catch (e) {
        Swal.close();
        Swal.fire({
            icon: "error",
            title: "Erreur",
            didOpen: () => { Swal.hideLoading() },
            html: "Erreur lors de l'envoi du formulaire :<br>" + e
        });
        return new Promise((resolve, reject) => {
            resolve({ isSuccess: false, errorMessage: ("Erreur lors de l'envoi du formulaire :<br>" + e) });
        });
    }
}

export function showDialogMaterial(title, tag, curMaterial, materialModels, saveMaterialVar, saveCb, modalGenManager, parentProps, i18nManager, isDuplicate) {
    var modalRoot;
    //Traitement des informations retourné par le Dialog
    var callbackModal = function (data, isUpdate) {
        return new Promise((resolve, reject) => {
            if (data) {
                //isUpdate = false;//TEMP : Recréation du material (voir pour les associations client etc..)
                saveMaterialVar(data, curMaterial, isUpdate, i18nManager, saveCb).then((dataResult) => {
                    if (dataResult && dataResult.idResponse) {
                        modalRoot.unmount();
                        resolve(dataResult);
                    }
                    else {
                        resolve(dataResult);
                    }
                });
            }
            else {
                modalRoot.unmount();
                resolve();
            }
        });
    };
    if (materialModels[tag]) {
        if (isDuplicate && !(curMaterial.parentID > 0)) curMaterial.parentID = curMaterial.idMaterial;

        modalRoot = createRoot(document.createElement('div'));
        //modalRoot.render(<MaterialModal modalGenManager={modalGenManager} noScroll noButtons props={parentProps} title={title} dialogBodyStyle2={{ height: "80vh" }} configModel={materialModels[tag]} modelsList={materialModels} dataMaterial={curMaterial} callback={callbackModal}></MaterialModal>);
        modalRoot.render(<MaterialModal modalGenManager={modalGenManager} noScroll noButtons props={parentProps} title={title} dialogBodyStyle2={{ height: "80vh" }} configModel={materialModels[tag]} configTag={tag} modelsList={materialModels} dataMaterial={curMaterial} isDuplicate={isDuplicate} i18nManager={i18nManager} callback={callbackModal}></MaterialModal>);
    }
    else {
        Swal.fire({
            icon: "error",
            title: i18nManager.t("gal_error"),
            html: "Configuration introuvable"
        });
    }
}

export function dialogAltMaterial(title, tag, curMaterial, materialModels, process, scheduleVisitCb, modalGenManager, parentProps, i18nManager) {
    var modalRoot;
    //Traitement des informations retourné par le Dialog
    var callbackModal = function (data, isUpdate) {
        return new Promise((resolve, reject) => {
            if (data) {
                var cb = () => {
                    var req = { id: data.idMaterial, newStatus: (tag === "MATERIALLOSS" ? 3006 : 3004), newStep: -1 };
                    commonFunc.postMethod("../api/material/UpdateStatus", req).then((response) => {
                        if (response.data && response.data.isSuccess) {
                            if (scheduleVisitCb && typeof (scheduleVisitCb) === "function") { scheduleVisitCb(data); }
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: i18nManager.t("gal_fail"),
                                html: i18nManager.t("gal_failUpdStatus") + "<br/>" + response.data.errorMessage
                            });
                        }
                        resolve(response.data);
                    });
                };

                process(data, curMaterial, isUpdate, i18nManager, cb).then((dataResult) => {
                    if (dataResult && dataResult.idResponse) {
                        modalRoot.unmount();

                        resolve(dataResult);
                    }
                    else {
                        resolve(dataResult);
                    }
                });
            }
            else {
                modalRoot.unmount();
                resolve();
            }
        });
    };
    if (materialModels[tag]) {
        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<MaterialModal supClasses={"visitModal"} modalGenManager={modalGenManager} noScroll size={"lg"} props={parentProps} title={title} configModel={materialModels[tag]} configTag={tag} locked={tag === "DLG_MATERIAL"} modelsList={materialModels} dataMaterial={curMaterial} i18nManager={i18nManager} callback={callbackModal}></MaterialModal>);
    }
    else {
        Swal.fire({
            icon: "error",
            title: i18nManager.t("gal_error"),
            html: "Configuration introuvable"
        });
    }
}

export function sendEmailDialog(material, dataCfg, i18nManager) {
    var id = material.idMaterial;
    if (parseInt(id) > 0) {
        var title = i18nManager.t("material.title") + " • " + material.title + " • " + material.client?.name + " " + material.client?.firstName + (material.client?.compagny ? (" - " + material.client?.compagny) : "");// getDtValue("lstActs", id, "Name") + " " + getDtValue("lstActs", id, "FirstName");

        var modalRoot;

        //Traitement des informations retourné par le Dialog
        var callbackModal = function () {
            modalRoot.unmount();
        };

        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<EmailModal title={"Envoyer un Email  " + title} materialId={id} material={material} dataCfg={dataCfg} i18nManager={i18nManager} callback={callbackModal}></EmailModal>);

    } else {
        Swal.fire({
            icon: "error",
            title: "Echec",
            html: "Aucune intervention n'est sélectionnée dans la liste"
        });
    }
}

export function sendRecapEmailDialog(material, dataCfg, i18nManager) {
    var id = material.idMaterial;
    if (parseInt(id) > 0) {
        var title = i18nManager.t("material.title") + " • " + material.title + " • " + material.client?.name + " " + material.client?.firstName + (material.client?.compagny ? (" - " + material.client?.compagny) : "");// getDtValue("lstActs", id, "Name") + " " + getDtValue("lstActs", id, "FirstName");

        var modalRoot;

        //Traitement des informations retourné par le Dialog
        var callbackModal = function () {
            modalRoot.unmount();
        };

        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<EmailModal title={"Envoyer un Email  " + title} materialId={id} material={material} dataCfg={dataCfg} cfgTag="EMLRCP_CFG" i18nManager={i18nManager} callback={callbackModal}></EmailModal>);

    } else {
        Swal.fire({
            icon: "error",
            title: "Echec",
            html: "Aucune intervention n'est sélectionnée dans la liste"
        });
    }
}

export function MaterialModal({ title, props, modalGenManager, noScroll, noButtons, noSubmit, supClasses, size, dialogBodyStyle, configModel, configTag, locked, modelsList, dataMaterial, isDuplicate, i18nManager, callback }) {
    configModel = JSON.parse(JSON.stringify(configModel));

    const [initialized, setInitialized] = React.useState(configTag !== "DLG_MATERIAL" && configTag !== "NEWPERSON");
    const [dlgMaterial, setDlgMaterial] = React.useState(dataMaterial);


    React.useEffect(() => {
        if (!initialized && (configTag === "DLG_MATERIAL" || configTag === "NEWPERSON")) {
            var args = {};
            //args.id = dataMaterial?.clientID;
            //args.level = 2;
            args.id = dataMaterial?.idMaterial;
            args.level = 3;
            if (parseInt(args.id) > 0) {
                Swal.fire({
                    title: i18nManager.t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false
                });

                //commonFunc.getMethod("../api/client/GetClient", args).then((response) => {
                commonFunc.getMethod("../api/material/GetMaterial", args).then((response) => {
                    var data = response.data;
                    if (data.isSuccess) {
                        console.log(data.result);

                        Swal.close();

                        if (data.result) {
                            //dataMaterial.client = data.result;
                            //var newMaterial = dataMaterial;
                            var newMaterial = data.result;
                            newMaterial.client.contact = newMaterial.client?.contacts?.filter(contact => {
                                if (!contact.address) contact.address = { "idAddress": contact.addressID, "pc": 0, "city": "", "categ": "SITE", "title": "Adresse", "addressMain": "N/A" };// /!\ TODO : Perte valeur adresse du contact
                                return contact.contactType === "Prospect Appelant";
                            });
                            if (newMaterial.client?.contact?.length) newMaterial.client.contact = newMaterial.client.contact[0];
                            //else if (newMaterial.client?.contacts?.length) newMaterial.client.contact = newMaterial.client.contacts[0];
                            if (configTag === "NEWPERSON" && newMaterial.clientID <= 0) newMaterial.client = null;
                            if (isDuplicate && !(newMaterial.parentID > 0)) newMaterial.parentID = newMaterial.idMaterial;
                            setDlgMaterial(newMaterial);
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: i18nManager.t("gal_error"),
                            html: i18nManager.t("client.failLoadClient") + " :<br>" + data.errorMessage
                        });
                    }
                    setInitialized(true);
                });

            }
            else {
                setInitialized(true);
            }
        }
    }, []);


    if (locked) {
        configModel.disabled = true;
        configModel.subType = "breadcrumbNav";
        size = "xl";
        noButtons = false;
        noSubmit = true;
    }
    else if (configTag === "DLG_MATERIAL" && dlgMaterial) {
        configModel.subType = "breadcrumbNav";
    }

    return (
        <Modal isOpen={true} className={`dlg-step modal-material ${noScroll ? "modal-noscroll" : ""} ${supClasses}`} size={size ? size : "xl"} scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2 pt-0  scrollable" style={{ overflowX: "hidden", ...dialogBodyStyle }}>
                {/*initialized && <AGenerateModel parentProps={{ type: "material", dataCfg: props.dataCfg }} ref={modalGenManager} noButtons onSubmit={(data, isUpdate) => { return callback(data, isUpdate) }} appProps={props} checkRights={props.checkRights} getRoutes={props.getRoutes} configModel={configModel} modelsList={modelsList} loadedData={dlgMaterial} isStartDuplicate={isDuplicate} />*/}

            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                {noButtons ? "" :
                    <>{noSubmit ? "" : ((dlgMaterial?.idMaterial && !isDuplicate) ? <Button className="px-3" color="success" onClick={() => {
                        var generateModel = modalGenManager.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm(true);
                        }
                    }}><i className="fa fa-edit"></i>Modifier</Button> : <Button className="px-3" color="success" onClick={() => {
                        var generateModel = modalGenManager.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm();
                        }
                    }}><i className="fa fa-plus"></i>Ajouter</Button>)}
                        <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>Annuler</Button></>
                }
            </ModalFooter>
        </Modal>
    );
}

//Création du schéma pour le paramètrage du formulaire
const itvModalSchema = yup.object().shape({
    fromEmail: yup.object().required("Ce champ est obligatoire"),//.required("Ce champ est obligatoire"),
    targetsEmail: yup.array().min(1, "Veuillez renseigner un email").required("Ce champ est obligatoire"),//.required("Ce champ est obligatoire"),
    files: yup.array(),//.required("Ce champ est obligatoire"),
    objectLabel: yup.string().required("Ce champ est obligatoire")
}).required();

function EmailModal({ title, materialId, material, dataCfg, cfgTag, i18nManager, callback }) {
    React.useEffect(() => {
        //console.debug("mount");

        initEmailModal();
    }, []);

    const [froms, setFroms] = React.useState([]);
    const [contacts, setContacts] = React.useState([]);
    const [files, setFiles] = React.useState([]);
    const [objEml, setObjEml] = React.useState(null);
    const [emailStatus] = React.useState(<Col lg="10" className="alert alert-sm mb-0 wait" id="errorEmailAlert"><span className="input-icon">En Attente</span><span className="ms-3">Patientez SVP...</span></Col>);
    const [modelTemplates, setModelTemplates] = React.useState([]);
    const [template, setTemplate] = React.useState("");

    const editorRef = React.useRef(null);

    const { register, getValues, setValue, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(itvModalSchema) });//{ resolver: yupResolver(currSchema), defaultValues: { ClientName: "toto" } }

    /*const { ref: refTgtEmail, ...restTgtEmail } =*/ register("targetsEmail");
    /*const { ref: refFiles, ...restFiles } =*/ register("files", { value: [] });
    const { ref: refObjectLabel, ...restObjectLabel } = register("objectLabel");

    function initEmailModal() {
        Swal.fire({
            title: i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var argsModel = { id: material.assignSiteID, level: 2 };
        commonFunc.getMethod("../api/site/GetSite", argsModel).then((responseSite) => {
            if (responseSite.data.isSuccess) {
                material.extSite = responseSite.data.result;

                var argsModel = { id: -1, categ: "LEAD" };
                commonFunc.getMethod("../api/material/GetMaterialModels", argsModel).then((response) => {
                    if (response.data.isSuccess) {
                        if (response.data.result?.models) {
                            var mailModel = response.data.result?.models.filter(model => model.extID === (cfgTag || "EML_CFG"));
                            if (mailModel.length) {
                                var objEmlCurr = JSON.parse(mailModel[0].value);
                                setObjEml(objEmlCurr);

                                if (objEmlCurr?.Email?.Subject) setValue("objectLabel", objEmlCurr?.Email?.Subject);
                                if (objEmlCurr?.Email?.From) {
                                    setFroms([{ value: objEmlCurr.Email.From.Item1, label: objEmlCurr.Email.From.Item2 }, { value: material.extSite?.email, label: material.extSite?.name + " (" + material.extSite?.email + ")" }]);
                                    if (objEmlCurr.SetDefaultFromSvcIDs && objEmlCurr.SetDefaultFromSvcIDs[material.serviceID]) {
                                        var defaultEmail = objEmlCurr.SetDefaultFromSvcIDs[material.serviceID];
                                        if (defaultEmail === objEmlCurr.Email.From.Item1) setValue("fromEmail", { email: objEmlCurr.Email.From.Item1, name: objEmlCurr.Email.From.Item2, firstName: "" });
                                        else setValue("fromEmail", { email: defaultEmail, name: defaultEmail, firstName: "" });
                                    }
                                    else setValue("fromEmail", { email: material.extSite?.email, name: material.extSite?.name, firstName: "" });
                                }
                                else {
                                    setValue("fromEmail", { email: material.extSite?.email, name: material.extSite?.name, firstName: "" });
                                }

                                var args = { id: materialId };
                                /*commonFunc.getMethod("../api/material/GetMaterialContacts", args).then((response) => {
                                    var data = response.data;
                                    if (data.isSuccess) {
                                        var defaultClient = [];
                                        if (!commonFunc.isBlank(material.client?.email)) defaultClient.push({ email: material.client?.email, name: material.client?.name, firstName: material.client?.firstName });

                                        var contacts = [...defaultClient, ...data.result];

                                        setContacts(contacts);
                                    }
                                    //else {
                                    //    Swal.fire({
                                    //        icon: "warning",
                                    //        title: "Attention",
                                    //        html: "Aucun contacts"
                                    //    });
                                    //}
                                });*/
                                var contacts = [];
                                var defaultClient = [];
                                if (!cfgTag || cfgTag === "EML_CFG") {
                                    if (!commonFunc.isBlank(material.client?.email)) {
                                        defaultClient.push({ email: material.client?.email, name: material.client?.name, firstName: material.client?.firstName });
                                    /*if (!cfgTag || cfgTag === "EML_CFG")*/ setValue("targetsEmail", [defaultClient[0]]);
                                    }

                                    contacts = [...defaultClient, ...material.contacts];
                                }

                                setContacts(contacts);
                                //setValue("targetsEmail", [{ email: material.client?.email, name: material.client?.name, firstName: material.client?.firstName }]);

                                if (objEmlCurr?.IncludeFiles) {
                                    //Appel réseau plutôt que dépendance sur material qui n'est pas actualisé juste après génération PDF
                                    var argsFiles = { bindID: args.id, fileId: -1 };
                                    commonFunc.getMethod("../api/material/GetMaterialFiles", argsFiles).then((response) => {//GetReportFinalFiles
                                        var data = response.data;
                                        var filteredFiles = [];
                                        if (material.materialFiles?.length > 0) {
                                            filteredFiles = material.materialFiles.map(file => file.file);
                                        }
                                        if (data.isSuccess && data.count > 0) {
                                            data.result.forEach((distantFile) => {
                                                var founded = filteredFiles.filter(localFile => localFile.idFile === distantFile.idFile);
                                                if (founded.length <= 0) filteredFiles.push(distantFile);
                                            });
                                        }

                                        if (objEmlCurr.Email?.FilesTypes) filteredFiles = filteredFiles.filter(file => objEmlCurr.Email.FilesTypes.indexOf(file.categ) >= 0);

                                        if (filteredFiles.length > 1) {
                                            filteredFiles = filteredFiles.sort((a, b) => {
                                                return moment(b.dSysMod).diff(a.dSysMod, "seconds");
                                            });
                                        }

                                        setFiles(filteredFiles);
                                        if (filteredFiles.length) setValue("files", [filteredFiles[0]]);
                                    });
                                }

                                /*commonFunc.getMethod("../weatherforecast/WFGetEmailStatus", null).then((response) => {
                                    if (response.data.isSuccess) {
                                        setEmailStatus(<Col lg="10" className="alert alert-sm mb-0 success alert-success" id="errorEmailAlert"><span className="input-icon">Actif</span><span className="ms-3"></span></Col>);
                                    } else {
                                        setEmailStatus(<Col lg="10" className="alert alert-sm mb-0 failure alert-danger" id="errorEmailAlert"><span className="input-icon">InActif</span><span className="ms-3">{response.data.errorMessage}</span></Col>);
                                    }
                                });*/

                                if (objEmlCurr?.Email?.ModelCateg && objEmlCurr?.Email?.ModelExtId) {
                                    //var argsModel = { filter: "material", useParentSite: true, excludeMode: 0, categ: objEmlCurr?.Email?.ModelCateg };
                                    //commonFunc.getMethod("../api/data/GetAllModels", argsModel).then((response) => {
                                    var argsModel = { id: -1, categ: objEmlCurr?.Email?.ModelCateg };
                                    commonFunc.getMethod("../api/material/GetMaterialModels", argsModel).then((response) => {
                                        if (response.data.isSuccess && response.data.result) {
                                            //console.debug(response.data.result);
                                            var mailModel = response.data.result.models.filter(model => objEmlCurr?.Email?.ModelExtId.indexOf(model.extID) >= 0);
                                            if (mailModel.length) {
                                                setModelTemplates(mailModel);
                                                updateHtmlContent(mailModel[0]);
                                            }


                                        }/* else {
                                            Swal.fire({
                                                icon: "error",
                                                title: "Echec",
                                                html: "Echec du chargement du template l'email<br/>" + response.data.errorMessage
                                            });
                                        }*/
                                    });
                                }

                                Swal.close();

                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Echec",
                                    html: "Echec du chargement de la configuration email<br/>Configuration introuvable"
                                });
                            }
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: "Echec du chargement de la configuration email<br/>Aucune configuration"
                            });
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec du chargement de la configuration email<br/>" + response.data.errorMessage
                        });
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Echec",
                    html: "Echec de récupération infos agences<br/>" + responseSite.data.errorMessage
                });
            }
        });
    }

    function updateHtmlContent(model, customContent) {
        var objHtml = JSON.parse(model.value);

        var htmlProc = () => {
            var content = customContent || objHtml.Details;
            var temp = document.createElement('div');
            temp.innerHTML = content;

            temp.querySelectorAll("[data-bind], [data-bindtype]").forEach((element) => {
                var valueBind;
                if (element.getAttribute("data-bindtype") === "address") {
                    valueBind = commonFunc.getValue(material, element.getAttribute("data-bind") + ".addressMain") + " ";
                    valueBind += commonFunc.getValue(material, element.getAttribute("data-bind") + ".addressPlus") + " ";
                    valueBind += commonFunc.getValue(material, element.getAttribute("data-bind") + ".addressPlus2") + " ";
                    valueBind += commonFunc.getValue(material, element.getAttribute("data-bind") + ".pc") + " ";
                    valueBind += commonFunc.getValue(material, element.getAttribute("data-bind") + ".city");
                }
                else if (element.getAttribute("data-bindtype")?.startsWith && element.getAttribute("data-bindtype").startsWith("contacts;")) {
                    valueBind = "";
                    var contacts = commonFunc.getValue(material, element.getAttribute("data-bind"));
                    if (contacts?.length) {
                        var filteredContacts = contacts.filter(contact => contact.contactType === element.getAttribute("data-bindtype").replace("contacts;", ""));
                        if (filteredContacts.length) {
                            valueBind = commonFunc.getValue(filteredContacts[0], element.getAttribute("data-subbind")) || ""
                        }
                    }
                    if (commonFunc.isBlank(valueBind) && element.getAttribute("data-fallback")) {
                        var subObj = commonFunc.getValue(material, element.getAttribute("data-fallback"));
                        if (subObj) valueBind = commonFunc.getValue(subObj, element.getAttribute("data-subbind")) || "";
                    }
                }
                else {
                    valueBind = commonFunc.getValue(material, element.getAttribute("data-bind")) || "";
                }

                if (element.getAttribute("data-format") === "phone") {
                    valueBind = valueBind.replaceAll(" ", ".");
                }

                element.innerHTML = valueBind;
            });
            setTemplate("<br/>" + temp.innerHTML);
        };


        if (objHtml.ShopOrderDependence) {
            commonFunc.getMethod("../api/material/GetLastShopOrderFromMaterial", { materialId: materialId }).then((response) => {
                if (response.data.isSuccess) {
                    material.shopOrder = response.data.result;

                    htmlProc();
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Echec de récupération de la dépendance<br/>" + response.data.errorMessage
                    });
                }
            });
        }
        else {
            htmlProc();
        }
    }

    function triggerSubmit(data) {

        Swal.fire({
            title: 'Envoi de l\'Email en cours...',
            didOpen: () => { Swal.showLoading() },
        });

        ///console.debug(data);
        var args = objEml.Email;
        args.BindID = materialId;
        args.From = { Item1: data.fromEmail.email, Item2: data.fromEmail.name + (data.fromEmail.firstName ? (" " + data.fromEmail.firstName) : "") };
        args.To = {};
        data.targetsEmail.forEach(target => { args.To[target.email] = target.name + (target.firstName ? (" " + target.firstName) : "") });
        args.Subject = data.objectLabel;
        args.Attachments = data.files;
        args.SrcObject = materialId;
        args.ModelBindID = materialId;

        args.HtmlMessage = editorRef.current ? editorRef.current.getContent() : "";
        args.PlainMessage = editorRef.current ? editorRef.current.getContent({ format: "text" }) : "";
        console.debug(args);
        //return;//TEMP
        commonFunc.postMethod("../api/material/SendMaterialEmail", args).then((response) => {
            if (response.data && response.data.isSuccess) {
                Swal.fire({
                    icon: "success",
                    title: i18nManager.t("gal_success"),
                    html: "Email envoyé avec succès",
                    didOpen: () => { Swal.hideLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                }).then((result) => {
                    if (callback && typeof (callback) === "function") { callback(data); }
                });

            } else {
                Swal.fire({
                    icon: "error",
                    title: "Echec",
                    html: "Echec de l'envoi de l'email<br/>" + response.data.errorMessage
                });
            }
        });
    }

    //console.debug("render modal");

    //console.debug(getValues());
    //console.debug(errors);

    var bindPropResult = "targetsEmail";
    //var currValue = "";
    var inputStyle = {};

    var onChange = () => { };

    var customOpt = [];
    contacts.forEach((option, index) => {
        customOpt.push({ value: option.email, label: option.name + " " + option.firstName + " (" + option.email + ")" });
    });
    /*if (getValues(bindPropResult)) currValue = getValues(bindPropResult);
    else if (customOpt.length) currValue = customOpt[0].value;*/

    var compArgs = {
        isMulti: true,
        id: "targetContactsEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResult) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    var contactSrc = contacts.filter(contact => contact.email === v.value);
                    if (contactSrc.length) return contactSrc[0];
                    else return { email: v.value, name: v.label };
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResult, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResult, e.value);
            }
        },
        isValidNewOption: (inputValue, value) => {
            return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(inputValue);// /[a-z]+@[a-z]+\.[a-z]+/
        },
        invalid: commonFunc.getValue(errors, bindPropResult) ? true : false,
        options: customOpt,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (contacts?.length) {
        compArgs.key = "emails" + contacts?.length;
        if (!cfgTag || cfgTag === "EML_CFG") compArgs.defaultValue = { label: customOpt[0].label, value: customOpt[0].value };
    }


    var bindPropResultF = "fromEmail";
    var fromArgs = {
        isMulti: false,
        id: "fromsEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResultF) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    return { email: v.value, name: v.label };
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResultF, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResultF, { email: e.value, name: e.label });
            }
        },
        isValidNewOption: (inputValue, value) => {
            return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(inputValue);// /[a-z]+@[a-z]+\.[a-z]+/
        },
        invalid: commonFunc.getValue(errors, bindPropResultF) ? true : false,
        options: froms,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (froms?.length) {
        fromArgs.key = "froms" + froms?.length;
        var defaultFrom = froms.filter(from => from.value === getValues("fromEmail")?.email);
        if (defaultFrom?.length) fromArgs.defaultValue = { label: defaultFrom[0].label, value: defaultFrom[0].value };
        else fromArgs.defaultValue = { label: froms[0].label, value: froms[0].value };
    }


    var bindPropResultFiles = "files";
    //var currValueFiles = "";

    var customOptFiles = [];
    files.forEach((option, index) => {
        customOptFiles.push({ value: option.idFile, label: option.name + " (" + option.prefix + ")" });
    });

    var selFilesArgs = {
        isMulti: true,
        id: "targetFilesEmail",
        className: ` ${commonFunc.getValue(errors, bindPropResultFiles) ? "react-select-invalid" : ""}`,
        isDisabled: false, /*innerRef={refElem} {...restElem}*/
        formatOptionLabel: (option, { context }) => {
            return option.label;
        },
        onChange: (e) => {
            //console.debug(e);
            if (Array.isArray(e)) {
                var values = e;
                values = e.map(v => {
                    var fileSrc = files.filter(contact => contact.idFile === v.value);
                    if (fileSrc.length) return fileSrc[0];
                    else return null;
                });
                //values = e.map(v => v.value).join(";");
                onChange(values);
                setValue(bindPropResultFiles, values);
            }
            else {
                onChange(e.value);
                setValue(bindPropResultFiles, e.value);
            }
        },
        invalid: commonFunc.getValue(errors, bindPropResultFiles) ? true : false,
        options: customOptFiles,
        //styles: { control: inputStyle }
        styles: { /*option: (provided, state) => ({ ...provided, ...inputStyle }),*/ control: (provided) => ({ ...provided, ...inputStyle }) }
    };

    if (files?.length) {
        selFilesArgs.key = "files" + files?.length;
        selFilesArgs.defaultValue = { label: customOptFiles[0].label, value: customOptFiles[0].value };
    }

    return (
        <Modal isOpen={true} className="modal-email" size="xl" keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title || "Transfert de Fichiers"}</ModalHeader>
            <ModalBody className="px-2">
                <Row className="m-0 mb-3 px-1 d-none">
                    <Col className="align-content-center text-lg-end" lg="2">
                        <label className="m-0">Etat du service:</label>
                    </Col>
                    {emailStatus}
                </Row>
                <div className="mail-box">
                    <Form id="frmsendmail" action="" className="form needs-validation" method="" onSubmit={handleSubmit(triggerSubmit)}>
                        <div className="mail-body">
                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">De:</label>
                                    </Col>
                                    <Col lg="8">
                                        {froms?.length ? <Select {...fromArgs} options={froms} /> : (() => {
                                            var email = getValues("fromEmail");
                                            return email ? (email.name + " (" + email.email + ");") : "";
                                        })()}
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "fromEmail") ? "d-block" : ""}`}>{errors.fromEmail ? errors.fromEmail.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">A:</label>
                                    </Col>
                                    <Col lg="8">
                                        {<CreatableSelect {...compArgs} />/*contacts?.length ? <CreatableSelect {...compArgs} /> : (() => {
                                            var emails = getValues("targetsEmail");
                                            return emails?.map(option => option.name + "(" + option.email + ");");
                                        })()*/}
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "targetsEmail") ? "d-block" : ""}`}>{errors.targetsEmail ? errors.targetsEmail.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0 mandatory">Objet:</label>
                                    </Col>
                                    <Col lg="10">
                                        <Input id="targetSubject" name="Objet" placeholder="Objet" type="text" autoComplete="off" aria-autocomplete="none"
                                            innerRef={refObjectLabel} {...restObjectLabel}
                                            invalid={errors.objectLabel ? true : false} />
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "objectLabel") ? "d-block" : ""}`}>{errors.objectLabel ? errors.objectLabel.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup>

                            {objEml?.IncludeFiles ? <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0">Fichiers:</label>
                                    </Col>
                                    <Col lg="10">
                                        <Select {...selFilesArgs} />
                                        <FormFeedback className={`text-start ${commonFunc.getValue(errors, "files") ? "d-block" : ""}`}>{errors.files ? errors.files.message : "Ce champ est obligatoire"}</FormFeedback>
                                    </Col>
                                </Row>
                            </FormGroup> : ""}

                            <FormGroup>
                                <Row>
                                    <Col className="align-content-center text-lg-end" lg="2">
                                        <label className="m-0">Type de message:</label>
                                    </Col>
                                    <Col lg="6">
                                        <Input id={"selectMsgType"} style={inputStyle} type="select" onChange={(e) => {
                                            var model = modelTemplates.filter(model => model.idModel === parseInt(e.target.value));
                                            if (model.length) {
                                                updateHtmlContent(model[0]);
                                            }
                                        }}>
                                            {modelTemplates.map((option, index) => <option key={"messagetype" + index} value={option.idModel}>
                                                {option.title}
                                            </option>)}
                                        </Input>
                                    </Col>
                                </Row>
                            </FormGroup>

                        </div>
                        <Editor
                            onInit={(evt, editor) => editorRef.current = editor}
                            initialValue={template}
                            init={{
                                language: "fr_FR",
                                valid_elements: '*[*]',
                                valid_children: "+body[style]",
                                height: 410,
                                menubar: false,
                                //readonly: true, >> cf disabled
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'help', 'wordcount'
                                ],
                                toolbar: 'undo redo | blocks | fontsize | ' +
                                    'bold italic forecolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat',
                                content_style: `body { font-family:Helvetica,Arial,sans-serif; font-size:14px} 
                                #mtnfr {font-family:Nunito} 
                                .sepline { border: 1px dashed red; }
                                .displayNone { display: none }
                                .d-none { display: none }`
                            }}
                        />
                        <button type="button" id="btnSaveEmailSig" className="btn btn-sm btn-simple btn-dark btn-ok mt-3 d-none"><i className="fa fa-pencil-alt"></i>&nbsp;Définir signature</button>
                    </Form>
                </div>

            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="primary" form="frmsendmail"><i className="fa fa-reply"></i>Envoyer</Button>
                <Button className="px-3" color="secondary" onClick={() => { callback(); }}>Fermer</Button>
            </ModalFooter>
        </Modal>
    );
}